import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRipIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "m4 20 6-8M4 4l6 8M10 12l5-8h5M10 12l5 8h5" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 12,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 4,
			r: 1.5,
			fill: "currentColor",
			stroke: "none",
			opacity: .5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 20,
			r: 1.5,
			fill: "currentColor",
			stroke: "none",
			opacity: .5
		})
	]
});
export default SvgRipIcon;
